var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-17 14:23:28
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-05-24 16:32:41
 * @Description:
 * @Developer:
 */
import React, { useEffect, useState } from 'react';
import { Tag, TreeSelect } from 'antd';
import Api from '../../api';
import { isArray } from 'lodash';
const api = Api();
export default function APITreeSelect(props) {
    const [data, setData] = useState([]);
    const loadData = props.loader ? (node) => __awaiter(this, void 0, void 0, function* () {
        if (props.loader) {
            const url = typeof (props.loader) === 'string'
                ? props.loader : props.loader.children;
            const res = (yield api.get(url, { params: Object.assign(Object.assign({}, (props.params || {})), { path: node.full_path }) }));
            setData((current) => {
                return [...current, ...res.filter((item) => !current.find((node) => node.full_path === item.full_path)).map((item) => {
                        const leaf = props.depth && props.depth <= item.full_path.split('/').length || item.leaf;
                        return Object.assign(Object.assign({ key: item.full_path, value: item.full_path, title: item.name }, item), { pId: item.parent_id, isLeaf: leaf, checkable: !props.leafCheckableOnly || leaf, selectable: !props.leafSelectableOnly || leaf });
                    })];
            });
        }
    }) : undefined;
    useEffect(() => {
        if (props.loader) {
            const url = typeof (props.loader) === 'string'
                ? props.loader : props.loader.root;
            api.get(url, { params: props.params })
                .then((data) => {
                setData(data.map((item) => {
                    const leaf = props.depth && props.depth <= item.full_path.split('/').length || item.leaf;
                    return Object.assign({ key: item.full_path, value: item.full_path, title: item.name, isLeaf: leaf, checkable: !props.leafCheckableOnly || leaf, selectable: !props.leafSelectableOnly || leaf, pId: 0 }, item);
                }));
            });
        }
    }, []);
    useEffect(() => {
        if (props.value && props.loader) {
            const values = (isArray(props.value) ? props.value : [props.value])
                .filter((item) => {
                return !data.find((node) => node.full_path === item);
            });
            const url = typeof (props.loader) === 'string'
                ? props.loader : props.loader.children;
            Promise
                .all(values.map((item) => api.get(url, {
                params: Object.assign(Object.assign({}, (props.params || {})), { path: item.substring(0, item.lastIndexOf('/')) })
            })))
                .then((children) => {
                setData((current) => {
                    return [...current, ...children
                            .flat()
                            .filter((item, index, array) => {
                            return array.findIndex((element) => element.id === item.id) === index;
                        })
                            .map((item) => {
                            const leaf = props.depth && props.depth <= item.full_path.split('/').length || item.leaf;
                            return Object.assign(Object.assign({ key: item.full_path, value: item.full_path, title: item.name }, item), { pId: item.parent_id, isLeaf: leaf, checkable: !props.leafCheckableOnly || leaf, selectable: !props.leafSelectableOnly || leaf });
                        })];
                });
            });
        }
    }, [props.value]);
    const attributes = Object.assign({}, props);
    delete attributes.leafSelectableOnly;
    delete attributes.leafCheckableOnly;
    return (React.createElement(TreeSelect, Object.assign({}, attributes, { dropdownStyle: { maxHeight: 400, overflow: 'auto' }, tagRender: (props) => {
            const items = props.value.split('/');
            return (React.createElement(Tag, Object.assign({ key: props.value }, props, { className: 'ant-select-selection-item', children: data.filter((node) => items.includes(node.id)).map((node) => node.name).join('/') })));
        }, treeDataSimpleMode: true, loadData: loadData, treeData: data })));
}
